// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"abf54fd3","2521":"1fd6c6ae","2813":"1fd6c6ae","9668":"1fd6c6ae"}[chunkId] + ".chunk.css";
};